import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { goBack, replace } from 'react-router-redux';
import lodash from 'lodash';

import {
    loadDocument,
    resetIndexDocument,
    unloadIndexDocument,
} from 'indexDocuments/actions';

import { documentDownloadRequest } from 'part11/actions/documents';

import {
    getSelectedDocumentType,
    getAutonameValue,
    getFilteredDocumentTypes,
    getDescriptors,
} from 'indexDocuments/selectors';

import { binderInstitutionIdSelector } from 'common/selectors';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';

import IndexDocumentDisplay from 'indexDocuments/components/IndexDocumentDisplay/IndexDocumentDisplay';

class IndexDocument extends Component {
    componentDidMount() {
        const { resetIndexDocument, initialDocumentTypeId } = this.props;
        resetIndexDocument();
        this.loadData(initialDocumentTypeId);
        this.collapseSidebar(true);
    }

    componentDidUpdate(prevProps) {
        this.navigateBackUnlessDocumentTypes();
        this.redirectAfterSave(prevProps);
    }

    componentWillUnmount() {
        this.props.unloadIndexDocument();
        this.collapseSidebar(false);
    }

    render() {
        const {
            loading,
            loaded,
            failedToLoad,
            binder,
            document,
            documentTypesVisibility,
            documentTypeFilter,
            documentTypes,
            selectedDocumentType,
            descriptors,
            autonameValue,
            indexingType,
            documentDownloadRequest,
        } = this.props;

        return <IndexDocumentDisplay
            loading={loading}
            loaded={loaded}
            reload={this.loadData.bind(this)}
            failedToLoad={failedToLoad}
            binder={binder}
            document={document}
            documentTypesVisibility={documentTypesVisibility}
            documentTypeFilter={documentTypeFilter}
            documentTypes={documentTypes}
            selectedDocumentType={selectedDocumentType}
            descriptors={descriptors}
            autonameValue={autonameValue}
            indexingType={indexingType}
            documentDownloadRequest={documentDownloadRequest}/>;
    }

    collapseSidebar(value) {
        const { setSidebarCollapsed } = this.props;
        if (lodash.isFunction(setSidebarCollapsed)) {
            setSidebarCollapsed(value);
        }
    }

    loadData(initialDocumentTypeId) {
        const { loadDocument, documentId, binderId, indexingType } = this.props;
        loadDocument(documentId, binderId, indexingType, initialDocumentTypeId);
    }

    redirectAfterSave(prevProps) {
        const { saveComplete: wasSaveComplete } = prevProps;
        const {
            saveComplete,
            goBack,
            successfulSaveRedirect,
            replace,
            redirectToSdfa,
            addApplicationMessage,
            binderId,
            document,
        } = this.props;
        const finishedSaving = !wasSaveComplete && saveComplete;
        if( finishedSaving ) {
            addApplicationMessage('success', 'You have indexed the document.');
            if ( redirectToSdfa ) {
                const sdfaUrl = {
                    pathname: '/form/process/sdfa',
                    query: {
                        docid: document.id,
                        iid: document.institutionId,
                    },
                    hash: `#${binderId}`,
                };
                replace(sdfaUrl);
            }
            else {
                if(successfulSaveRedirect === 'none') {
                    window.close();
                }
                goBack();
            }
        }
    }

    navigateBackUnlessDocumentTypes() {
        const { hasDocumentTypes, loaded, goBack, addApplicationMessage, indexingType } = this.props;
        if (!loaded || indexingType === 'index') {
            return;
        }
        if (!hasDocumentTypes) {
            addApplicationMessage('error', 'You do not have access to any document types to index.');
            goBack();
        }
    }
}

IndexDocument.propTypes = {
    setSidebarCollapsed: PropTypes.func,
};

export default connect((state, props) => {
    const {
        indexDocument: {
            loading,
            loaded,
            failedToLoad,
            binder,
            document,
            documentTypesVisibility,
            documentTypeFilter,
            selectedDocumentTypeId,
            saveComplete,
            redirectToSdfa,
        },
    } = state;
    const institutionId = binderInstitutionIdSelector(state);
    const documentId = props.documentId || lodash.get(props, 'params.documentId');
    const binderId = props.binderId || lodash.get(props, 'params.id');
    const indexingType = props.indexingType || lodash.get(props, 'params.indexingType');
    const hasDocumentTypes = lodash.chain(state)
        .get('indexDocument.documentTypes')
        .some()
        .value();
    return {
        institutionId,
        documentId,
        binderId,
        loading,
        loaded,
        failedToLoad,
        binder,
        document,
        documentTypesVisibility,
        documentTypeFilter,
        hasDocumentTypes,
        documentTypes: getFilteredDocumentTypes(state),
        selectedDocumentTypeId,
        selectedDocumentType: getSelectedDocumentType(state),
        descriptors: getDescriptors(state),
        autonameValue: getAutonameValue(state),
        indexingType,
        saveComplete,
        redirectToSdfa,
    };
}, {
    loadDocument,
    resetIndexDocument,
    unloadIndexDocument,
    addApplicationMessage,
    goBack,
    replace,
    documentDownloadRequest,
})(IndexDocument);
